import Image from "next/image";
import smallLogo from "../../../../public/smallLogo.webp";
import headerLogo from "../../../../public/headerLogo.jpg";

export const SmallLogo = () => {
  return (
    <a
      href="/"
      className="w-16 inline xsmall:hidden focus:outline-none focus-visible:ring
focus-visible:ring-olive focus-visible:ring-offset-4 z-20"
    >
      <Image priority={true} src={smallLogo} alt="Home" />
    </a>
  );
};

export const Logo = () => {
  return (
    <a
      href="/"
      className="inline-block w-[30%]  group4:w-[10%] group3:w-[20%] p-4 focus:outline-none focus-visible:ring
  focus-visible:ring-olive focus-visible:ring-offset-4 z-20"
    >
      <Image priority={true} src={headerLogo} alt="Home" />
    </a>
  );
};
//128.8
//109.48
//113.7
